// extracted by mini-css-extract-plugin
module.exports = {"title":"_3oaka","message":"_3cPYF","rule":"E3iVM","checkboxDescription":"V6XJf","button":"Modg9","submitButton":"_2rBBW Modg9","error":"_3t8P_","footer":"_2le-0"};